// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event_wrapper {
  padding-top: 8%;
}

.event-wrapper {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%);
  height: auto;
  border-radius: 12px;
}

.event-container {
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: #fff;
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%);
  border-radius: 12px;
  /* height: 130vh; */
  width: 80%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
}

.event-frame {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%);
}

.event-frame img {
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3.5rem auto;
}

.event-content {
  justify-content: center;
  align-items: center;
  margin: 2rem auto;
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%);
}

.event-content h4,
p {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%);
}

.event_text {
  margin: auto 3.5rem;
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%);
}

.event_text h4 {
  font-family: Eczar;
  font-size: 24px;
  line-height: 30px;
}

.event_text p {
  font-family: Inter;
  font-size: 18px;
  font-weight: 400;
  margin-top: 8px;
  margin-bottom: 30px;
  line-height: 34px;
}

.event-btn {
  font-size: 18px;
  font-weight: 500;
  padding: 10px 30px;
  background-color: rgba(251, 133, 0, 1);
  border-radius: 64px;
  border: 3px solid rgba(75, 75, 75, 0.25);
  top: 412px;
  margin: auto 3.5rem;
}

.reserve-btn {
  background-color: rgba(28, 27, 38, 1);
}

.reserve-btn button {
  height: 48px;
  font-size: 16px;
  font-family: Inter;
  font-weight: 500;
  border-radius: 64px;
  border: solid 1px rgb(255, 198, 188);
  justify-content: center;
  gap: 10px;
  padding: 0;
  margin: auto 3.5rem;
  width: 192px;
  background-color: rgba(251, 133, 0, 1);
}

.replay_session_container {
  /* height: 407px; */
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: auto;
}

.replay_session_container h3 {
  font-size: 48px;
  font-family: Eczar;
  color: #b3b3b3;
}

.replay_session_container .text {
  /* height: 100px; */
  width: 80%;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #b3b3b3;
  /* padding: 2rem 0; */
  margin: 2rem 0;
}

.replay_session_container .oranges {
  font-size: 48px;
  height: 85px;
  color: rgba(251, 133, 0, 1);
  font-family: Eczar;
}

.session_main {
  display: flex;
  flex-wrap: wrap;
  /* gap: 2%; */
  gap: 1rem;
  /* padding-inline: 5%; */
  /* height: 30vh; */
  width: 80%;
  /* align-items: center; */
  align-items: stretch;
  justify-content: center;
}

.first_session,
.second_session {
  /* width: 60%; */
  border-radius: 16px;
  font-size: 14px;
  color: #b3b3b3;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 16px);
}

.first_session h3,
.second_session h3 {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(0deg, rgba(75, 75, 75, 0.25), rgba(75, 75, 75, 0.25));
  font-size: 24px;
  color: #b3b3b3;
}

.first_session p,
.second_session p {
  font-size: 18px;
  font-weight: 400;
  font-family: Inter;
  /* line-height: 2rem; */
}

.ses-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #b3b3b3;
  border-radius: 12px;
  border: 3px solid rgba(75, 75, 75, 0.25);
  padding: 1rem;
  height: 100%;
  /* height: 247px; */
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(0deg, rgba(75, 75, 75, 0.25), rgba(75, 75, 75, 0.25));
}

.ses_paragraph {
  height: 100px;
  margin: 10px 0;
  background-color: rgba(28, 27, 38, 1);
}

.ses-content button {
  background-color: rgba(251, 133, 0, 1);
  height: 3rem;
  width: 9rem;
  border-radius: 4px;
  border: 1px solid #ffccbc51;
  /* margin: 0 auto; */
}

.session_link {
  text-decoration: none;
  margin-top: 20px;
}

.session_link a {
  font-family: Eczar;
  font-weight: 400;
  font-size: 16px;
  border-style: none;
  border-radius: 4px;
  text-decoration: none;
  color: #fff;
  background-color: rgba(251, 133, 0, 1);
}

.replay {
  margin-top: 4.5rem;
  margin-bottom: 48px;
}

.past_para {
  font-family: Inter;
  font-size: 20px;
  color: #fb8500;
  justify-content: center;
  text-align: center;
  background: #15141d;
  margin-bottom: 20px;
}

.play_sessions {
  color: #b3b3b3;
  width: 80%;
  align-items: center;
  justify-content: center;
  margin: 10px auto;
}

.playback_session {
  display: flex;
  flex-wrap: wrap;
  border: 3px solid rgba(75, 75, 75, 0.25);
  border-radius: 14px;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
}

.playback {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.333% - 1rem);
  /* width: 30%;
  height: 100%; */
}

.playback .entry_level {
  flex-wrap: wrap;
  /* margin-top: 16px;
  margin-bottom: 16px; */
  height: 320px;
  transition: 0.3s;
}

.replay_playback_container h1 {
  font-family: Eczar;
  color: #b3b3b3;
  justify-content: center;
  align-items: center;
  text-align: center;
  /* width: 778px; */
  margin: 0 auto;
  height: 180px;
}

@media screen and (max-width:768px) {

  .first_session,
  .playback {
    flex: 1 1 100%;
  }

  .event_text {
    margin-inline: unset;
    padding-inline: clamp(1rem, 3%, 2rem);
  }

  .events_div {
    margin-top: 5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Events.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE;;;kCAGgC;EAChC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX;;;kCAGgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE;;;kCAGgC;AAClC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB;;;kCAGgC;AAClC;;AAEA;;EAEE;;;kCAGgC;AAClC;;AAEA;EACE,mBAAmB;EACnB;;;kCAGgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;AAC5B;;AAEA;;EAEE;yEACuE;EACvE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB;yEACuE;AACzE;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAA8B;EAA9B,cAA8B;EAA9B,gCAA8B;EAC9B;iBACe;AACjB;;AAEA;EACE,eAAe;EACf;wBACsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE;;IAEE,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".event_wrapper {\n  padding-top: 8%;\n}\n\n.event-wrapper {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%);\n  height: auto;\n  border-radius: 12px;\n}\n\n.event-container {\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  color: #fff;\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%);\n  border-radius: 12px;\n  /* height: 130vh; */\n  width: 80%;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin: 0 auto;\n}\n\n.event-frame {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%);\n}\n\n.event-frame img {\n  width: 90%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 3.5rem auto;\n}\n\n.event-content {\n  justify-content: center;\n  align-items: center;\n  margin: 2rem auto;\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%);\n}\n\n.event-content h4,\np {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%);\n}\n\n.event_text {\n  margin: auto 3.5rem;\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%);\n}\n\n.event_text h4 {\n  font-family: Eczar;\n  font-size: 24px;\n  line-height: 30px;\n}\n\n.event_text p {\n  font-family: Inter;\n  font-size: 18px;\n  font-weight: 400;\n  margin-top: 8px;\n  margin-bottom: 30px;\n  line-height: 34px;\n}\n\n.event-btn {\n  font-size: 18px;\n  font-weight: 500;\n  padding: 10px 30px;\n  background-color: rgba(251, 133, 0, 1);\n  border-radius: 64px;\n  border: 3px solid rgba(75, 75, 75, 0.25);\n  top: 412px;\n  margin: auto 3.5rem;\n}\n\n.reserve-btn {\n  background-color: rgba(28, 27, 38, 1);\n}\n\n.reserve-btn button {\n  height: 48px;\n  font-size: 16px;\n  font-family: Inter;\n  font-weight: 500;\n  border-radius: 64px;\n  border: solid 1px rgb(255, 198, 188);\n  justify-content: center;\n  gap: 10px;\n  padding: 0;\n  margin: auto 3.5rem;\n  width: 192px;\n  background-color: rgba(251, 133, 0, 1);\n}\n\n.replay_session_container {\n  /* height: 407px; */\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n}\n\n.replay_session_container h3 {\n  font-size: 48px;\n  font-family: Eczar;\n  color: #b3b3b3;\n}\n\n.replay_session_container .text {\n  /* height: 100px; */\n  width: 80%;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  color: #b3b3b3;\n  /* padding: 2rem 0; */\n  margin: 2rem 0;\n}\n\n.replay_session_container .oranges {\n  font-size: 48px;\n  height: 85px;\n  color: rgba(251, 133, 0, 1);\n  font-family: Eczar;\n}\n\n.session_main {\n  display: flex;\n  flex-wrap: wrap;\n  /* gap: 2%; */\n  gap: 1rem;\n  /* padding-inline: 5%; */\n  /* height: 30vh; */\n  width: 80%;\n  /* align-items: center; */\n  align-items: stretch;\n  justify-content: center;\n}\n\n.first_session,\n.second_session {\n  /* width: 60%; */\n  border-radius: 16px;\n  font-size: 14px;\n  color: #b3b3b3;\n  flex: 1 1 calc(50% - 16px);\n}\n\n.first_session h3,\n.second_session h3 {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(0deg, rgba(75, 75, 75, 0.25), rgba(75, 75, 75, 0.25));\n  font-size: 24px;\n  color: #b3b3b3;\n}\n\n.first_session p,\n.second_session p {\n  font-size: 18px;\n  font-weight: 400;\n  font-family: Inter;\n  /* line-height: 2rem; */\n}\n\n.ses-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  color: #b3b3b3;\n  border-radius: 12px;\n  border: 3px solid rgba(75, 75, 75, 0.25);\n  padding: 1rem;\n  height: 100%;\n  /* height: 247px; */\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(0deg, rgba(75, 75, 75, 0.25), rgba(75, 75, 75, 0.25));\n}\n\n.ses_paragraph {\n  height: 100px;\n  margin: 10px 0;\n  background-color: rgba(28, 27, 38, 1);\n}\n\n.ses-content button {\n  background-color: rgba(251, 133, 0, 1);\n  height: 3rem;\n  width: 9rem;\n  border-radius: 4px;\n  border: 1px solid #ffccbc51;\n  /* margin: 0 auto; */\n}\n\n.session_link {\n  text-decoration: none;\n  margin-top: 20px;\n}\n\n.session_link a {\n  font-family: Eczar;\n  font-weight: 400;\n  font-size: 16px;\n  border-style: none;\n  border-radius: 4px;\n  text-decoration: none;\n  color: #fff;\n  background-color: rgba(251, 133, 0, 1);\n}\n\n.replay {\n  margin-top: 4.5rem;\n  margin-bottom: 48px;\n}\n\n.past_para {\n  font-family: Inter;\n  font-size: 20px;\n  color: #fb8500;\n  justify-content: center;\n  text-align: center;\n  background: #15141d;\n  margin-bottom: 20px;\n}\n\n.play_sessions {\n  color: #b3b3b3;\n  width: 80%;\n  align-items: center;\n  justify-content: center;\n  margin: 10px auto;\n}\n\n.playback_session {\n  display: flex;\n  flex-wrap: wrap;\n  border: 3px solid rgba(75, 75, 75, 0.25);\n  border-radius: 14px;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  justify-content: center;\n  align-items: center;\n}\n\n.playback {\n  flex: 1 1 calc(33.333% - 1rem);\n  /* width: 30%;\n  height: 100%; */\n}\n\n.playback .entry_level {\n  flex-wrap: wrap;\n  /* margin-top: 16px;\n  margin-bottom: 16px; */\n  height: 320px;\n  transition: 0.3s;\n}\n\n.replay_playback_container h1 {\n  font-family: Eczar;\n  color: #b3b3b3;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  /* width: 778px; */\n  margin: 0 auto;\n  height: 180px;\n}\n\n@media screen and (max-width:768px) {\n\n  .first_session,\n  .playback {\n    flex: 1 1 100%;\n  }\n\n  .event_text {\n    margin-inline: unset;\n    padding-inline: clamp(1rem, 3%, 2rem);\n  }\n\n  .events_div {\n    margin-top: 5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
